import React from 'react'

import Menu, { SubMenu, Item as MenuItem, Divider } from 'rc-menu'

import 'rc-menu/assets/index.css'
import { animation } from './helper'
import { MenuClickEventHandler, MenuMode, TriggerSubMenuAction } from 'rc-menu/lib/interface'

function CommomMenu({
    children,
    mode,
    defaultOpenKeys,
    triggerSubMenuAction,
    onClick
}: // updateChildrenAndOverflowedIndicator
{
    children: JSX.Element[]
    mode: MenuMode
    triggerSubMenuAction: TriggerSubMenuAction
    defaultOpenKeys: string[]
    onClick: MenuClickEventHandler
    // updateChildrenAndOverflowedIndicator: boolean
}): JSX.Element {
    return (
        <div
            style={{
                overflow: 'hidden',
                backgroundColor: 'white'
            }}
        >
            <Menu
                onClick={onClick}
                forceSubMenuRender={true}
                // triggerSubMenuAction={triggerSubMenuAction}
                // onOpenChange={onOpenChange}
                // selectedKeys={defaultOpenKeys}
                mode={mode}
                defaultOpenKeys={defaultOpenKeys}
                // overflowedIndicator={overflowedIndicator}
            >
                {children}
            </Menu>
        </div>
    )
}
export { CommomMenu }
